//==本JS是加载Lodop插件及CLodop服务的综合示例，可直接使用，建议看懂后融进自己页面程序==

import {Notification} from 'element-ui';
import {envElectron} from "../api/electronUtils";

let CreatedOKLodopObject, CLodopIsLocal, CLodopJsState;

//==判断是否需要CLodop(那些不支持插件的浏览器):==
function needCLodop(ipStr) {
  try {
    let ua = navigator.userAgent;
    if (ua.match(/Windows\sPhone/i))
      return true;
    if (ua.match(/iPhone|iPod|iPad/i))
      return true;
    if (ua.match(/Android/i))
      return true;
    if (ua.match(/Edge\D?\d+/i))
      return true;

    let verTrident = ua.match(/Trident\D?\d+/i);
    let verIE = ua.match(/MSIE\D?\d+/i);
    let verOPR = ua.match(/OPR\D?\d+/i);
    let verFF = ua.match(/Firefox\D?\d+/i);
    let x64 = ua.match(/x64/i);
    if ((!verTrident) && (!verIE) && (x64))
      return true;
    else if (verFF) {
      verFF = verFF[0].match(/\d+/);
      if ((verFF[0] >= 41) || (x64))
        return true;
    } else if (verOPR) {
      verOPR = verOPR[0].match(/\d+/);
      if (verOPR[0] >= 32)
        return true;
    } else if ((!verTrident) && (!verIE)) {
      let verChrome = ua.match(/Chrome\D?\d+/i);
      if (verChrome) {
        verChrome = verChrome[0].match(/\d+/);
        if (verChrome[0] >= 41)
          return true;
      }
    }
    return false;
  } catch (err) {
    return true;
  }
}

//==加载引用CLodop的主JS,用双端口8000和18000(以防其中一个被占):==
function loadCLodop() {
  if (CLodopJsState == "loading" || CLodopJsState == "complete") return;
  CLodopJsState = "loading";
  let head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
  let JS1 = document.createElement("script");
  let JS2 = document.createElement("script");
  JS1.src = "http://localhost:8000/CLodopfuncs.js?priority=1";
  JS2.src = "http://localhost:18000/CLodopfuncs.js";
  JS1.onload = JS2.onload = function () {
    CLodopJsState = "complete";
  };
  JS1.onerror = JS2.onerror = function (evt) {
    CLodopJsState = "complete";
  };

  try{
    head.insertBefore(JS1, head.firstChild);
    head.insertBefore(JS2, head.firstChild);
    CLodopIsLocal = !!((JS1.src + JS2.src).match(/\/\/localho|\/\/127.0.0./i));
  }catch (e) {
    console.log("连接打印模块失败")
  }
}

if (needCLodop()) {
  if (!envElectron()){
    loadCLodop();
  }
}//加载

//==获取LODOP对象主过程,判断是否安装、需否升级:==
export function getLodop(ipStr, oOBJECT, oEMBED) {
  let strHtmInstall = "打印控件未安装!安装后请刷新页面或重新进入";
  let strHtmUpdate = "打印控件需要升级,升级后请重新进入。";
  let strHtmFireFox = "（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）";
  let strHtmChrome = "(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）";
  let strCLodopInstall_1 = "Web打印服务CLodop未安装启动";
  let strCLodopUpdate = "Web打印服务CLodop需升级,升级后请刷新页面。";

  let LODOP;
  try {
    let ua = navigator.userAgent;
    let isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i));
    if (needCLodop(ipStr)) {
      try {
        LODOP = getCLodop();
      } catch (err) {
      }
      if (!LODOP && CLodopJsState !== "complete") {
        if (CLodopJsState == "loading")
          Notification.warning("网页还没下载完毕，请稍等一下再操作."); else
          Notification.warning("没有加载CLodop的主js，请先调用loadCLodop过程.");
        return;
      }
      if (!LODOP) {
        Notification.warning(strCLodopInstall_1);
        return;
      } else {
        if (CLODOP.CVERSION < "4.1.1.8") {
          Notification.warning(strCLodopUpdate);
        }
        if (oEMBED && oEMBED.parentNode)
          oEMBED.parentNode.removeChild(oEMBED); //清理旧版无效元素
        if (oOBJECT && oOBJECT.parentNode)
          oOBJECT.parentNode.removeChild(oOBJECT);
      }
    } else {
      var is64IE = isIE && !!(ua.match(/x64/i));
      //==如果页面有Lodop就直接使用,否则新建:==
      if (oOBJECT || oEMBED) {
        if (isIE)
          LODOP = oOBJECT;
        else
          LODOP = oEMBED;
      } else if (!CreatedOKLodopObject) {
        LODOP = document.createElement("object");
        LODOP.setAttribute("width", 0);
        LODOP.setAttribute("height", 0);
        LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
        if (isIE)
          LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");
        else
          LODOP.setAttribute("type", "application/x-print-lodop");
        document.documentElement.appendChild(LODOP);
        CreatedOKLodopObject = LODOP;
      } else
        LODOP = CreatedOKLodopObject;
      //==Lodop插件未安装时提示下载地址:==
      if ((!LODOP) || (!LODOP.VERSION)) {
        if (ua.indexOf('Chrome') >= 0)
          Notification.warning(strHtmChrome);
        if (ua.indexOf('Firefox') >= 0)
          Notification.warning(strHtmFireFox);
        return LODOP;
      }
    }
    if (LODOP.VERSION < "6.2.2.6") {
      if (!needCLodop())
        Notification.warning(strHtmUpdate);
    }

    let hostname  = document.location.hostname;
    console.log(hostname)
    //===如下空白位置适合调用统一功能(如注册语句、语言选择等):==
    if (hostname.indexOf("mrcargo.com") !== -1) {
      LODOP.SET_LICENSES("", "AEF78C99500D791D8FC86E55566381869C9", "", "");
    } else if (hostname.indexOf("woodx3.com") !== -1) {
      LODOP.SET_LICENSES("", "D4A5C6835DC8DCF502491A3BF8D23D516A7", "", "");
    }else{
      LODOP.SET_LICENSES("", "", "", "");
    }

    //=======================================================
    return LODOP;
  } catch (err) {
    Notification.warning("getLodop出错:" + err);
  }
}





// WEBPACK FOOTER //
// ./src/config/LodopFuncs.js